var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-bin-trash-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 162638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0985 5.5H2.93945",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7101 7.58398L15.327 13.3332C15.1796 15.5457 15.1059 16.6519 14.3854 17.3262C13.665 18.0007 12.5569 18.0007 10.3408 18.0007H9.69672C7.48055 18.0007 6.37249 18.0007 5.65204 17.3262C4.9316 16.6519 4.85789 15.5457 4.71047 13.3332L4.32739 7.58398",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.93677 9.66602L8.35343 13.8327",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1015 9.66602L11.6848 13.8327",
    stroke: "#FD2233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.43848 5.5C5.48502 5.5 5.50829 5.5 5.52939 5.49947C6.21521 5.48208 6.82024 5.04576 7.05361 4.40027C7.06079 4.38041 7.06815 4.35833 7.08287 4.31414L7.16373 4.07142C7.23276 3.86423 7.26727 3.76063 7.31305 3.67267C7.4957 3.32172 7.83362 3.07803 8.22414 3.01564C8.32202 3 8.43118 3 8.64948 3H11.3892C11.6075 3 11.7166 3 11.8145 3.01564C12.205 3.07803 12.5429 3.32172 12.7256 3.67267C12.7714 3.76063 12.8059 3.86423 12.8749 4.07142L12.9558 4.31414C12.9705 4.35827 12.9779 4.38042 12.985 4.40027C13.2184 5.04576 13.8234 5.48208 14.5093 5.49947C14.5304 5.5 14.5536 5.5 14.6002 5.5",
    stroke: "#FD2233",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b80635fc7394ccc40f289dad2048e231.svg";
export { ForwardRef as ReactComponent };